import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TerraIconModule } from '@ninety/terra';
import { ProgressBarComponent } from '@ninety/ui/core';

import { Phase } from '../../models/phase';

@Component({
  selector: 'ninety-phase',
  templateUrl: './phase.component.html',
  styleUrls: ['./phase.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TerraIconModule, ProgressBarComponent],
})
export class PhaseComponent {
  @Input() phase: Phase;
  @Input() previousPhaseTitle?: string;
}
